module.exports = __webpack_public_path__ + "assets/images/service_ticket.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/service_ticket.png
// module id = 406
// module chunks = 1